import React, { useContext } from "react"
import PropTypes from "prop-types"
import styles from "./contentSearch.module.scss"
import { Link } from "gatsby"
import FaqLayout from "../faq-layout"
import Layout from "../layout"

const ContentSearch = ({ handleChange, placeholder, value, result = [] }) => {
  const faqLayoutContextValue = useContext(FaqLayout.context)
  const { showResult, setShowResult } = faqLayoutContextValue
  const layoutContextValue = useContext(Layout.context)
  const { disableHeaderParam } = layoutContextValue
  return (
    <div className={styles.inputContainer}>
      <div id={styles.searchIcon}></div>
      <input
        type="text"
        onChange={handleChange}
        value={value}
        className={styles.formInput}
        placeholder={placeholder}
        onClick={() =>
          result.length > 0 && !showResult ? setShowResult(true) : null
        }
      />
      {result.length > 0 && showResult && (
        <div className={styles.resultList}>
          {result.map((item, index) => {
            return (
              <Link
                key={index}
                to={`/faq${item.slug}${disableHeaderParam}`}
                className={styles.resultItem}
              >
                {item.name}
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}

ContentSearch.propTypes = {
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  result: PropTypes.array,
}
ContentSearch.defaultProps = {
  placeholder: "Search a keyword e.g “POS Issue",
  handleChange: () => null,
  value: "",
  result: [],
}

export default ContentSearch
